import type { Params } from '@angular/router';
import type { RouterReducerState } from '@ngrx/router-store';
import { routerReducer } from '@ngrx/router-store';
import { createFeatureSelector } from '@ngrx/store';

import type { ApplicationType as Application } from '@evc/platform';

import * as BreadcrumbReducer from './breadcrumb/breadcrumb.reducer';
import * as BrowseTargetReducer from './browse-target/browse-target.reducer';
import * as CellarReducer from './cellar/cellar.reducer';
import * as ClipboardReducer from './clipboard/clipboard.reducer';
import * as FileReducer from './file/file.reducer';
import * as UploadReducer from './upload/upload.reducer';

export type RouterStateUrl = {
  url: string;
  queryParams: Params;
  params: Params;
  data: Record<string, any>;
};
export type AppsState = {
  loading: boolean;
  loaded: boolean;
  applications: Application[];
  error: string | null;
};

export type NdtFileManagerState = {
  router: RouterReducerState<RouterStateUrl>;
  file: FileReducer.FileState;
  clipboard: ClipboardReducer.ClipboardState;
  breadcrumb: BreadcrumbReducer.BreadcrumbState;
  upload: UploadReducer.UploadState;
  browseTarget: BrowseTargetReducer.BrowseTargetState;
  cellar: CellarReducer.CellarState;
};

export const ndtFileManagerStoreReducers: any = {
  router: routerReducer,
  file: FileReducer.fileReducer,
  clipboard: ClipboardReducer.clipboardReducer,
  breadcrumb: BreadcrumbReducer.breadcrumbReducer,
  upload: UploadReducer.uploadReducer,
  browseTarget: BrowseTargetReducer.browseTargetReducer,
  cellar: CellarReducer.cellarReducer,
};

export const getFileManagerState: any =
  createFeatureSelector<NdtFileManagerState>('ndtFileManager');

export * from './file/file.reducer';
export * from './clipboard/clipboard.reducer';
export * from './breadcrumb/breadcrumb.reducer';
export * from './upload/upload.reducer';
export * from './browse-target/browse-target.reducer';
export * from './cellar/cellar.reducer';
